function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgIconSearch = function SvgIconSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 16,
    width: 16,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M6.495.012C2.918.012 0 2.93 0 6.507s2.918 6.495 6.495 6.495a6.449 6.449 0 003.907-1.323l4.05 4.05a.895.895 0 101.264-1.265l-4.05-4.05a6.449 6.449 0 001.324-3.907c0-3.577-2.918-6.495-6.495-6.495zm0 1.692a4.79 4.79 0 014.803 4.803 4.79 4.79 0 01-4.803 4.803 4.79 4.79 0 01-4.803-4.803 4.79 4.79 0 014.803-4.803z",
    style: {
      lineHeight: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      blockProgression: "tb",
      whiteSpace: "normal",
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: 1
    },
    color: "#000",
    fontWeight: 400,
    fontFamily: "sans-serif",
    overflow: "visible",
    fill: "#bdbdbd"
  }));
};

export default SvgIconSearch;